/** Single frontend upload rule for photos and photo counts. Bytes are decimal MB, as the backend counts them.
 *  The design fields only mirror the server: no frontend path gates PSD/INDD by them, the 800 MB cap is server-side. */
export const UPLOAD_LIMITS = {
  photoExtensions: ['jpg', 'jpeg', 'webp', 'png', 'heic', 'heif'],
  photoMaxBytes: 50 * 1000 * 1000,
  designExtensions: ['indd', 'psd'],
  designMaxBytes: 800 * 1000 * 1000,
  bookMaxPhotos: 500,
  fotoclassProjectMaxPhotos: 2000,
} as const;

/** How long a landed photo waits for its server previews before the UI gives up on them: one wait for every product. */
export const UPLOAD_PROCESSING_DEADLINE_MS = 180_000;

/**
 * Минимальный размер файла (для фильтрации битых/пустых файлов)
 */
export const MIN_FILE_SIZE = 10 * 1024; // 10 KB

/** Photo size cap: every consumer gates photos only (after isImageFile). */
export const MAX_FILE_SIZE = UPLOAD_LIMITS.photoMaxBytes;

/**
 * Минимальное разрешение по длинной стороне (для качественной печати)
 */
export const MIN_IMAGE_LONG_SIDE = 1000;
